import { Button, Modal } from "@etframework/ui.components";
import { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useDeleteMultipleTasks } from "../../data/mutations/taskMutations";
import useEvent from "../../hooks/useEvent";
import useModalEvent from "../../hooks/useModalEvent";

export const DeleteConfirmationModal = () => {
  const { t } = useTranslation(["DeleteConfirmationModal"]);

  const [vm, setVM] = useState({
    name: null,
    client: null,
    requestId: null
  });

  const { mutate: deleteMultipleTasks, isPending } = useDeleteMultipleTasks();
  const { Events, toggleEvent } = useEvent();

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    modalRef?.current?.close();
  };

  const openModal = () => {
    setShowModal(true);
    modalRef?.current?.open();
  };

  const onModalClose = () => {
    setShowModal(false);
  };

  const toggleModal = (event) => {
    setVM(event?.detail);
    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const onDelete = () => {
    const deleteTasks = { TasksIds: vm?.requestId };

    deleteMultipleTasks(
      { tasks: deleteTasks },
      {
        onSuccess: () => {
          toggleEvent(Events.RefreshTaskGrid);
          toast.success(t("DeleteSuccess"), { position: "bottom-left" });
          toggleEvent(Events.CloseTaskOverlay);

          onModalClose();
        },
        onError: () => {
          toast.error(t("ErrorMsg"), { position: "bottom-left" });
        }
      }
    );
  };

  const ModalContent = () => {
    return (
      <>
        <div className="text-center pb-4">
          <div className="fw-600 fs-16">{t("DeleteConfirmation")}</div>
          <span className="text-red">{t("AllDataLost")}</span>
        </div>
        <div className="d-flex flex-column bg-light rounded gap-2 p-2">
          <div className="d-flex gap-2">
            <span className="">{t("Name")}:</span>
            <span className="fw-semibold">{vm?.name}</span>
          </div>
          <div className="d-flex gap-2">
            <span className="">{t("Client")}:</span>
            <span className="fw-semibold">{vm?.client}</span>
          </div>
        </div>

        <div className="d-flex justify-content-end board-modal-btns gap-3 pt-4">
          <Button
            text={t("Cancel")}
            className="btn-tertiary w-auto"
            onClick={onModalClose}
          />
          <Button
            id={ModalEvents.DeleteConfirmationModal.Id + "_delete-button"}
            text={t("Delete")}
            className="btn btn-danger w-auto"
            onClick={onDelete}
            loading={isPending}
          />
        </div>
      </>
    );
  };

  useRegisterEvent(ModalEvents.DeleteConfirmationModal, toggleModal);

  return ReactDOM.createPortal(
    <>
      <Modal
        id={ModalEvents.DeleteConfirmationModal.Id}
        ref={modalRef}
        isModal
        showCloseIcon={true}
        visible={showModal}
        content={<ModalContent />}
        close={onModalClose}
        minHeight="20vh"
        width="487px"
      ></Modal>
    </>,
    document.body
  );
};
